export enum FileErrorEnum {
  UNSUPPORTED_FILE_TYPE = 'Unsupported file type',
  GENERIC_ERROR = 'Please try again',
}
